import { useBillingScheduleId } from 'BillingScheduleHome/utils/useBillingScheduleId'
import { useBillingScheduleAggregate } from 'BillingScheduleHome/utils/useBillingScheduleAggregate'
import { ScheduleTimeline } from '../timeline/ScheduleTimeline'
import { ErrorBoundary } from 'common/components/ErrorBoundary/ErrorBoundary'
import {
  GreyGrey30,
  GreyGrey70,
  Primary13SemiBold,
  Box,
  Flex
} from '@sequencehq/core-components'
import { Skeleton } from '@sequencehq/core-components'
import { TIMELINE_AXIS_HEIGHT_PX } from '../timeline/timeline.constants'
import { SectionError } from '../common/SectionError'

export const useScheduleTimelineData = (props: {
  billingScheduleId: string
}) => {
  const billingScheduleAggregateQuery = useBillingScheduleAggregate({
    billingScheduleId: props.billingScheduleId,
    select: data => {
      const scheduleStartDate = data.billingSchedule.startDate
      const scheduleEndDate = data.billingSchedule.endDate

      return {
        phases: data.billingSchedule.phases,
        prices: data.prices,
        recurrenceDayOfMonth: data.billingSchedule.recurrenceDayOfMonth,
        startDate: scheduleStartDate,
        endDate: scheduleEndDate
      }
    }
  })

  return {
    isLoading: billingScheduleAggregateQuery.isPending,
    isError: billingScheduleAggregateQuery.isError,
    scheduleTimelineData: billingScheduleAggregateQuery.data
  }
}

const TimelineError = () => {
  return (
    <Flex
      height={`${TIMELINE_AXIS_HEIGHT_PX}px`}
      alignItems="center"
      justifyContent="center"
      gap="4px"
      {...Primary13SemiBold}
      color={GreyGrey70}
      borderTop={`1px solid ${GreyGrey30}`}
    >
      <SectionError
        size="small"
        text="An error occurred when loading the timeline"
      />
    </Flex>
  )
}

export const SecheduleTimelineSection = () => {
  const billingScheduleId = useBillingScheduleId()
  const { isLoading, isError, scheduleTimelineData } = useScheduleTimelineData({
    billingScheduleId
  })

  if (isLoading || !scheduleTimelineData) {
    return (
      <Box
        height={`${TIMELINE_AXIS_HEIGHT_PX}px`}
        width="100%"
        padding="8px"
        borderTop={`1px solid ${GreyGrey30}`}
      >
        <Skeleton height="100%" width="100%" />
      </Box>
    )
  }

  if (isError) {
    return <TimelineError />
  }

  return (
    <ErrorBoundary
      name="ScheduleTimelineSection"
      fallback={() => <TimelineError />}
    >
      <ScheduleTimeline scheduleData={scheduleTimelineData} />
    </ErrorBoundary>
  )
}
